import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideo20 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M3 4C1.89543 4 1 4.89543 1 6V14C1 15.1046 1.89543 16 3 16H11C12.1046 16 13 15.1046 13 14V6C13 4.89543 12.1046 4 11 4H3Z",
			fill: "#8A49CA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7931 7.86677C14.6146 7.94791 14.5 8.12589 14.5 8.32196V11.678C14.5 11.8741 14.6146 12.0521 14.7931 12.1332L19.2931 14.1787C19.6241 14.3292 20 14.0871 20 13.7235V6.2765C20 5.91286 19.6241 5.67084 19.2931 5.82132L14.7931 7.86677Z",
			fill: "#8A49CA"
		})
	]
});
const ForwardRef = forwardRef(SvgVideo20);
export { ForwardRef as ReactComponent };
